<template>
    <div class="page-container">
        <div class="page-tab">
            <div class="tab-item" :class="{actived:currentTab == 0}" @click="changeTab(0)">全部</div>
            <div class="tab-item" :class="{actived:currentTab == 1}" @click="changeTab(1)">待发货</div>
            <div class="tab-item" :class="{actived:currentTab == 2}" @click="changeTab(2)">已发货</div>
            <div class="tab-item" :class="{actived:currentTab == 3}" @click="changeTab(3)">已完成</div>
        </div>
        <div class="order-list" v-if="list.length > 0">
            <div class="stock-item" v-for="(item,index) in list" :key="index" @click="jumpDetail(index,item.orderId)">
                <div class="time-status">
                    <span>订单编号：{{item.orderNo}}</span>
                    <div class="stock-status-img">
                        {{
                            item.orderState == 5 || item.orderState == 7 ? '待发货' :
                            item.orderState == 6 ? '已发货' :
                            item.orderState == 10 ? '已完成' : ''
                        }}
                    </div>
                </div>
                <div class="goods-bock" v-for="(goodsItem,goodsIndex) in item.recordList" :key="goodsIndex * 1000">
                    <img :src="goodsItem.goodIconUrl" class="goods-pic">
                    <div class="goods-info-block">
                        <div class="goods-detail">
                            <div class="goods-name">{{`${goodsItem.goodName} ${goodsItem.goodDegree}度 ${goodsItem.goodCapacity}`}}</div>
                            <!-- <div class="caigou-price">¥{{goodsItem.amount}}</div> -->
                        </div>
                        <div class="price-count">
                            <div class="goods-price">{{goodsItem.unit == '箱' ? '整箱(6瓶)' : '单瓶'}}</div>
                            <div class="goods-count">x{{goodsItem.num}}({{goodsItem.unit}})</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="bottom-line">
                    <span>{{item.createTime | createtimeNotime}}</span> <span>总发货：12箱+12瓶</span>
                </div>   -->
                <!-- <div class="order-address"><span>（收）</span>{{`${item.receiveName} ${item.receiveMobile} ${item.receiveAddress}`}}</div> -->
                <div class="btn-line">
                    <div class="btn-item" @click.stop="goStrack(item.orderId)">查看物流</div>
                </div>
            </div>
        </div>
        <!-- 无记录 -->
        <van-empty v-else :image=nullImg description="暂无数据~" />
    </div>
</template>
<script>

import $http from '@/lib/request'
import config from '@/config'
import {Toast,Empty} from 'vant'

export default {
    data(){
        return {
            currentTab:0,//0 全部，1 待发货，2 已发货，3 已完成，4 待处理
            list:[],//数据列表
            nullImg:require('@/assets/icon-null.png'),
        }
    },
    components:{
        [Toast.name]:Toast,
        [Empty.name]:Empty
    },
    activated(){
        this.loadData();
    },
    methods:{
        loadData(){
            let tmpState=this.currentTab == 0 ? '' :this.currentTab;
            $http({
                method:'post',
                url:config.api.deliveryOrder,
                data:{
                    status:tmpState
                }
            }).then(res=>{
                if(res.errno == 0){
                    this.list=res.data;
                }else{
                    Toast(res.errmsg);
                }
                
            })
        },
        changeTab(type){
            this.currentTab=type;
            this.list=[];
            this.loadData();
        },
        jumpDetail(index,oid){
            // this.$store.commit('updateCurrentPickupInfo',this.list[index]);
            this.$router.push({
                name:'pickup-detail',
                params:{
                    orderId:oid
                }
            });
        },
        goStrack(oid){
            this.$router.push({
                name:'order-tracking',
                params:{
                    orderId:oid
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .van-empty__image{
    width:140px;
    height:108px;
}
::v-deep .van-empty{
    margin-top: 50px;
}
.page-container{
    min-height:calc(100vh - 40px);
    background:#fafafa;
    padding-top: 40px;
    .page-tab{
        display: flex;
        justify-content: center;
        align-items: center;
        background:#fff;
        box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08);
        position: fixed;
        top:0;
        left:0;
        width:100%;
        z-index: 9;
        .tab-item{
            height:40px;
            line-height: 40px;
            width:25%;
            text-align: center;
            color:#333;
            font-size: 14px;
            position: relative;
            &.actived{
                color:#3088F5;
                &::after{
                    content: '';
                    display: block;
                    width:24px;
                    height:2px;
                    background:#3088F5;
                    position: absolute;
                    bottom: -1px;
                    left:50%;
                    transform: translateX(-50%);
                }
            }
        }
    }
    .order-list{
        padding:0 10px;
        margin-top: 10px;
        overflow: hidden;
        .stock-item{
            background:#fff;
            margin-bottom: 10px;
            padding:0 15px;
            @media screen and (max-width: 750px){
                border-radius: 4px;
            }
            .time-status{
                padding-top: 15px;
                padding-bottom: 15px;
                line-height: 20px;
                box-sizing: border-box;
                color:#333;
                border-bottom:1px solid #f0f0f0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 15px;
                .stock-status-img{
                    font-size: 14px;
                    color:#FFA820;
                }
            }
            .goods-bock{
                padding-top:15px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                .goods-pic{
                    width:80px;
                    height:80px;
                    margin-right: 10px;
                    border-radius: 4px;
                }
                .goods-info-block{
                    width:244px;
                    .goods-detail{
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        margin-bottom: 10px;
                        .goods-name{
                            // width:160px;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            color:#000;
                            line-height: 20px;
                            font-size: 14px;
                        }
                        .caigou-price{
                            color:#999;
                            line-height: 18px;
                            text-align: right;
                            font-size: 12px;
                        }
                    }
                }
                .price-count{
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    .goods-price{
                        width:160px;
                        color:#999;
                        line-height: 17px;
                        margin-bottom: 10px;
                        font-size: 12px;
                    }
                    .goods-count{
                        color:#3088F5;
                        line-height: 18px;
                        font-size: 13px;
                    }
                }
            }
            .order-address{
                height:40px;
                line-height: 40px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;
                color:#666;
                box-sizing: border-box;
                border-top:1px solid #f0f0f0;
                span{
                    color:#3088F5;
                }
            }
            .bottom-line{
                margin-top: 10px;
                margin-bottom: 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                &>span{
                    &:first-child{
                        color:#999;
                        line-height: 18px;
                        font-size: 13px;
                    }
                    &:last-child{
                        color:#3088F5;
                        font-size: 14px;
                    }
                }
            }
            .btn-line{
                padding-bottom: 15px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .btn-item{
                    width: 90px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    background: #FFFFFF;
                    border-radius: 26px;
                    border: 1px solid #DCDADA;
                    color:#333;
                    font-size: 14px;
                }
            }
        }
    }
}
</style>